// extracted by css-extract-rspack-plugin
export default {"agencyUnlimitedContainer":"hcLvtyR4ZXAWo5Jb","iconContainer":"BtLgpYzfUocUPLBO","content":"uAPfWT4S6VYe8Y47","title":"CGDxgYvaSYlPKQuV","message":"jlv1ivsC0X4YdRYK"};